/* ============================================================================
   PrimeStyle collection filters — PURE CORE (no DOM)
   ----------------------------------------------------------------------------
   Everything the approved filter drawer (landing-pages/filter-mockup, owner-approved
   2026-09-07) needs to DECIDE, kept apart from everything it needs to DRAW:
   canonical shape / metal / origin / stone tables, the product normalizer, the
   metal-from-variants reader, the matcher, the per-option counts, the price presets
   and the URL codec. ps-collection26.js draws the drawer with these; node --test
   runs them without a browser (tools/tests/filters26.test.mjs).

   Loaded by snippets/ps-col26-filters.liquid BEFORE the feed loader, so the mapper
   for products.json pages (>250 products) can call metalsFromVariants too.
   ========================================================================== */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.PSFilterCore = api;
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : null), function () {
  'use strict';

  /* ---- canonical tables ---- */
  var SHAPE_LABEL = {
    round: 'Round', princess: 'Princess', cushion: 'Cushion', oval: 'Oval', emerald: 'Emerald',
    radiant: 'Radiant', pear: 'Pear', marquise: 'Marquise', heart: 'Heart', asscher: 'Asscher',
    baguette: 'Baguette'
  };
  var SHAPE_ORDER = ['round', 'princess', 'cushion', 'oval', 'emerald', 'radiant', 'pear', 'marquise', 'heart', 'asscher', 'baguette'];
  /* Shapes with an illustrated symbol in the shared chrome sprite (ps-header-26 /
     _ds/partials/header.html, ids shp-<key>). Baguette has none and renders as a
     labelled tile without an illustration — never a broken <use>. */
  var SHAPE_ICONS = ['round', 'princess', 'cushion', 'oval', 'emerald', 'radiant', 'pear', 'marquise', 'heart', 'asscher'];
  /* The filter is by color, so 14K and 18K collapse into one swatch each; the
     configuration price a product shows under a metal is its cheapest AVAILABLE variant
     in that color, whichever karat. Platinum is its own color (and its own price). */
  var METALS = [
    { key: 'white',    label: 'White gold',  token: 'white' },
    { key: 'yellow',   label: 'Yellow gold', token: 'yellow' },
    { key: 'rose',     label: 'Rose gold',   token: 'rose' },
    { key: 'platinum', label: 'Platinum',    token: 'plat' }
  ];
  var METAL_ORDER = METALS.map(function (m) { return m.key; });
  var METAL_LABEL = {}; METALS.forEach(function (m) { METAL_LABEL[m.key] = m.label; });
  var ORIGIN_LABEL = { natural: 'Natural', lab: 'Lab-grown' };
  var ORIGIN_ORDER = ['natural', 'lab'];
  var STONE_LABEL = { blue: 'Fancy blue', pink: 'Fancy pink', yellow: 'Fancy yellow' };
  var STONE_ORDER = ['blue', 'pink', 'yellow'];
  var LIST_GROUPS = ['shape', 'metal', 'origin', 'stone'];
  var GROUP_ORDER = ['price', 'metal', 'shape', 'origin', 'stone'];
  var LABELS = { shape: SHAPE_LABEL, metal: METAL_LABEL, origin: ORIGIN_LABEL, stone: STONE_LABEL };
  var ORDERS = { shape: SHAPE_ORDER, metal: METAL_ORDER, origin: ORIGIN_ORDER, stone: STONE_ORDER };

  /* ---- option-value readers ---- */
  /* One Shopify option value -> a swatch key, or null when it is not one of the four
     colors this filter offers (two-tone, silver, an unexpected spelling). Unknown
     never becomes "white" by default: a missing color must not invent availability. */
  function metalKey(value) {
    var v = String(value == null ? '' : value).toLowerCase();
    if (!v) return null;
    if (v.indexOf('two') > -1 && v.indexOf('tone') > -1) return null;
    if (v.indexOf('platinum') > -1) return 'platinum';
    if (v.indexOf('white') > -1) return 'white';
    if (v.indexOf('yellow') > -1) return 'yellow';
    if (v.indexOf('rose') > -1 || v.indexOf('pink gold') > -1) return 'rose';
    return null;
  }
  /* Which option holds the metal. Name first (Metal/Color, Metal, Gold Color), then a
     values sniff for a product whose option is named oddly but clearly lists metals. */
  function metalOptionIndex(options) {
    options = options || [];
    for (var i = 0; i < options.length; i++) {
      var o = options[i]; var name = typeof o === 'string' ? o : (o && o.name) || '';
      if (/metal|gold|colou?r/i.test(name)) return i;
    }
    for (var j = 0; j < options.length; j++) {
      var vals = (options[j] && options[j].values) || [];
      if (vals.length && vals.filter(metalKey).length === vals.length) return j;
    }
    return -1;
  }
  /* products.json product -> {white:[startingPrice, compareAt|null], ...} from its
     AVAILABLE variants. This is the same fact the Liquid feed computes for the first 250
     products, so both halves of a large collection describe availability identically. */
  function metalsFromVariants(options, variants, fallback) {
    var idx = metalOptionIndex(options);
    if (idx < 0) return metalsFromTitle(fallback);
    var out = {}, any = false;
    (variants || []).forEach(function (v) {
      if (!v || v.available === false) return;
      var key = metalKey(v['option' + (idx + 1)] != null ? v['option' + (idx + 1)] : (v.options && v.options[idx]));
      if (!key) return;
      var price = Number(v.price);
      if (!isFinite(price) || price <= 0) return;
      var was = Number(v.compare_at_price);
      if (!isFinite(was) || was <= price) was = null;
      if (!out[key] || price < out[key][0]) { out[key] = [price, was]; any = true; }
    });
    return any ? out : null;
  }
  /* A piece with NO metal option (the ready-to-ship shelf: one finished item, one
     metal) is orderable in the single metal its title names. fallback = {title, price,
     compareAt, available}. Two metals in one title (two-tone) count for nothing. */
  function metalsFromTitle(fb) {
    if (!fb || fb.available === false) return null;
    var t = String(fb.title || '').toLowerCase();
    var price = Number(fb.price);
    if (!isFinite(price) || price <= 0) return null;
    if (/two[ -]?tone/.test(t)) return null;
    var keys = [];
    if (t.indexOf('platinum') > -1) keys.push('platinum');
    if (t.indexOf('white gold') > -1) keys.push('white');
    if (t.indexOf('yellow gold') > -1) keys.push('yellow');
    if (t.indexOf('rose gold') > -1 || t.indexOf('pink gold') > -1) keys.push('rose');
    if (keys.length !== 1) return null;
    var was = Number(fb.compareAt);
    var out = {};
    out[keys[0]] = [price, (isFinite(was) && was > price) ? was : null];
    return out;
  }

  /* ---- product normalizer: every product the filters see has valid keys or none ---- */
  function shapeKey(v) {
    var s = String(v == null ? '' : v).toLowerCase().trim();
    s = s.replace(/^shape_shape_/, '').replace(/^shape_/, '').split('__')[0].replace(/^ascher$/, 'asscher');
    return SHAPE_LABEL[s] ? s : null;
  }
  function normalizeProduct(p) {
    if (!p || typeof p !== 'object') return p;
    /* `shapes` = every cut the piece carries (the store's own shape_* tags: a
       "Princess & Round" ring is both). `shape` stays the single display value the
       cards and compare table already use. A filter choice matches any carried shape,
       so an accent cut is never mistaken for the centre and never hidden either. */
    var list = [];
    (Array.isArray(p.shapes) ? p.shapes : (p.shape != null ? [p.shape] : [])).forEach(function (v) {
      var k = shapeKey(v);
      if (k && list.indexOf(k) < 0) list.push(k);
    });
    if (list.length) p.shapes = list; else delete p.shapes;
    if (p.shape != null) {
      var s = shapeKey(p.shape);
      if (s) p.shape = s; else delete p.shape;
    }
    if (!p.shape && list.length) p.shape = list[0];
    if (p.origin != null) {
      var o = String(p.origin).toLowerCase();
      if (ORIGIN_LABEL[o]) p.origin = o; else delete p.origin;
    }
    if (p.fancyColor != null) {
      var f = String(p.fancyColor).toLowerCase();
      if (STONE_LABEL[f]) p.fancyColor = f; else delete p.fancyColor;
    }
    if (p.metals && typeof p.metals === 'object') {
      var m = {}, keep = false;
      Object.keys(p.metals).forEach(function (k) {
        if (!METAL_LABEL[k]) return;
        var v = p.metals[k];
        var now = Array.isArray(v) ? Number(v[0]) : Number(v);
        var was = Array.isArray(v) ? Number(v[1]) : NaN;
        if (!isFinite(now) || now <= 0) return;
        m[k] = [now, (isFinite(was) && was > now) ? was : null];
        keep = true;
      });
      if (keep) p.metals = m; else delete p.metals;
    } else if (p.metals != null) {
      delete p.metals;
    }
    p.priceNow = Number(p.priceNow);
    if (!isFinite(p.priceNow)) p.priceNow = 0;
    return p;
  }

  /* ---- state ---- */
  function cleanState() { return { shape: [], metal: [], origin: [], stone: [], min: null, max: null }; }
  function cloneState(s) {
    return { shape: s.shape.slice(), metal: s.metal.slice(), origin: s.origin.slice(), stone: s.stone.slice(), min: s.min, max: s.max };
  }
  function hasPrice(s) { return s.min !== null || s.max !== null; }
  function selectedCount(s) { return s.shape.length + s.metal.length + s.origin.length + s.stone.length + (hasPrice(s) ? 1 : 0); }
  function isEmpty(s) { return selectedCount(s) === 0; }
  function sameState(a, b) {
    return LIST_GROUPS.every(function (k) { return a[k].length === b[k].length && a[k].every(function (v) { return b[k].indexOf(v) > -1; }); })
      && a.min === b.min && a.max === b.max;
  }
  function validRange(s) {
    var ok = [s.min, s.max].every(function (v) { return v === null || (typeof v === 'number' && isFinite(v) && v >= 0); });
    return ok && !(s.min !== null && s.max !== null && s.min > s.max);
  }
  /* Text from a number field -> null (empty) | number | NaN (malformed). Only digits, one
     dot and an optional leading minus count as a number; "1e3", "abc", "1,000" are malformed. */
  function parseMoney(text) {
    var t = String(text == null ? '' : text).trim();
    if (t === '') return null;
    if (!/^-?\d*(\.\d*)?$/.test(t) || t === '-' || t === '.' || t === '-.') return NaN;
    return Number(t);
  }

  /* ---- matching ---- */
  /* The price a product is judged on: with a metal selection, its cheapest available
     configuration in one of the selected colors; without one, its starting price.
     null = no orderable configuration in the selected metals (so it cannot match). */
  function configPrice(p, metalSel) {
    if (!metalSel || !metalSel.length) return p.priceNow;
    if (!p.metals) return null;
    var best = null;
    metalSel.forEach(function (m) {
      var cfg = p.metals[m];
      if (cfg && (best === null || cfg[0] < best)) best = cfg[0];
    });
    return best;
  }
  /* The metal a card should open on under a selection: the first selected color the
     product is orderable in (in swatch order), or null when none applies. */
  function metalFor(p, metalSel) {
    if (!metalSel || !metalSel.length || !p.metals) return null;
    for (var i = 0; i < METAL_ORDER.length; i++) {
      var k = METAL_ORDER[i];
      if (metalSel.indexOf(k) > -1 && p.metals[k]) return k;
    }
    return null;
  }
  /* Photo-availability fallback for SNAPSHOT datasets only (the design mockups, whose
     products.js carries no variant data). Never used when the feed is live. */
  function photoMetals(p) {
    var bc = p.images && p.images.byColor;
    if (!bc) return null;
    var out = {}, any = false;
    METAL_ORDER.forEach(function (k) {
      var src = k === 'platinum' ? 'white' : k;
      if (bc[src]) { out[k] = [p.priceNow, p.priceWas || null]; any = true; }
    });
    return any ? out : null;
  }
  function carries(p, key) {
    if (p.shapes) return p.shapes.indexOf(key) > -1;
    return p.shape === key;
  }
  function matches(p, s) {
    if (s.shape.length) {
      var okShape = false;
      for (var j = 0; j < s.shape.length; j++) if (carries(p, s.shape[j])) { okShape = true; break; }
      if (!okShape) return false;
    }
    if (s.origin.length && s.origin.indexOf(p.origin) < 0) return false;
    if (s.stone.length && s.stone.indexOf(p.fancyColor) < 0) return false;
    if (s.metal.length) {
      if (!p.metals) return false;
      var okMetal = false;
      for (var i = 0; i < s.metal.length; i++) if (p.metals[s.metal[i]]) { okMetal = true; break; }
      if (!okMetal) return false;
    }
    if (hasPrice(s)) {
      var price = configPrice(p, s.metal);
      if (price === null) return false;
      if (s.min !== null && price < s.min) return false;
      if (s.max !== null && price > s.max) return false;
    }
    return true;
  }
  function countMatches(products, s) {
    var n = 0;
    for (var i = 0; i < products.length; i++) if (matches(products[i], s)) n++;
    return n;
  }
  /* Per-option counts: every OTHER group as drafted, this option alone in its own group
     (so alternatives within a group stay discoverable while the others narrow). */
  function optionCounts(products, draft, group, values) {
    var out = {};
    values.forEach(function (v) {
      var one = cloneState(draft); one[group] = [v];
      out[v] = countMatches(products, one);
    });
    return out;
  }

  /* ---- what a dataset can offer ---- */
  /* metalSel is optional: with a metal drafted, the price band chips are built from
     the prices that metal actually costs, so a chip cannot promise a band the grid
     then refuses to fill. */
  function availableValues(products, metalSel) {
    var seen = { shape: {}, metal: {}, origin: {}, stone: {} };
    var prices = [], hasMetalData = false;
    var sel = (metalSel && metalSel.length) ? metalSel : null;
    products.forEach(function (p) {
      if (p.shapes) p.shapes.forEach(function (k) { seen.shape[k] = 1; });
      else if (p.shape) seen.shape[p.shape] = 1;
      if (p.origin) seen.origin[p.origin] = 1;
      if (p.fancyColor) seen.stone[p.fancyColor] = 1;
      if (p.metals) { hasMetalData = true; Object.keys(p.metals).forEach(function (k) { seen.metal[k] = 1; }); }
      var pp = sel ? configPrice(p, sel) : p.priceNow;
      if (pp !== null && isFinite(pp) && pp > 0) prices.push(pp);
    });
    var out = { hasMetalData: hasMetalData, prices: prices };
    LIST_GROUPS.forEach(function (g) { out[g] = ORDERS[g].filter(function (k) { return seen[g][k]; }); });
    return out;
  }

  /* ---- price presets: rounded budget shortcuts with explicit, non-overlapping edges ---- */
  function niceStep(x) { return x < 1000 ? 100 : x < 5000 ? 250 : x < 10000 ? 500 : 1000; }
  function nice(x) { var st = niceStep(x); return Math.max(st, Math.round(x / st) * st); }
  function percentile(sorted, q) {
    if (!sorted.length) return 0;
    var pos = (sorted.length - 1) * q, lo = Math.floor(pos), hi = Math.ceil(pos);
    return sorted[lo] + (sorted[hi] - sorted[lo]) * (pos - lo);
  }
  function presets(prices, steps) {
    var edges;
    if (Array.isArray(steps) && steps.length) {
      edges = steps.map(Number).filter(function (n) { return isFinite(n) && n > 0; }).sort(function (a, b) { return a - b; });
      edges = edges.filter(function (n, i) { return i === 0 || n > edges[i - 1]; });
    } else {
      var sorted = prices.slice().sort(function (a, b) { return a - b; });
      if (sorted.length < 6) return [];
      var a = nice(percentile(sorted, 1 / 3)), b = nice(percentile(sorted, 2 / 3));
      if (b <= a) b = nice(percentile(sorted, 0.85));
      edges = b > a ? [a, b] : [a];
    }
    if (!edges.length) return [];
    var out = [];
    edges.forEach(function (e, i) {
      if (i === 0) out.push({ label: 'Under ' + money(e), min: null, max: round2(e - 0.01) });
      else out.push({ label: money(edges[i - 1]) + ' to ' + money(e), min: edges[i - 1], max: e });
    });
    var last = edges[edges.length - 1];
    out.push({ label: 'Over ' + money(last), min: round2(last + 0.01), max: null });
    return out;
  }
  function sliderMax(prices) {
    var max = 0;
    prices.forEach(function (n) { if (n > max) max = n; });
    return Math.max(500, Math.ceil(max / 500) * 500);
  }
  function round2(n) { return Math.round(n * 100) / 100; }

  /* ---- labels ---- */
  function money(n, cents) {
    var v = Number(n);
    var s = (cents ? v.toFixed(2) : Math.round(v).toString());
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    /* PSMoney (layout/ps26): the shopper's currency, never a hard-coded '$' (owner 2026-10-05). */
    if (window.PSMoney) return PSMoney.fmt(cents ? v : Math.round(v), cents ? 2 : 0);
    return '$' + parts.join('.');
  }
  function priceLabel(s) {
    if (s.min === null && s.max === null) return 'Any price';
    if (s.min === null) return 'Up to ' + money(s.max, true);
    if (s.max === null) return money(s.min, true) + ' and up';
    return money(s.min, true) + ' to ' + money(s.max, true);
  }
  function entries(s) {
    var out = [];
    LIST_GROUPS.forEach(function (k) {
      s[k].forEach(function (v) { out.push({ k: k, v: v, label: LABELS[k][v] || v }); });
    });
    if (hasPrice(s)) out.push({ k: 'price', v: 'range', label: priceLabel(s) });
    return out;
  }
  function remove(s, k, v) {
    if (k === 'price') { s.min = null; s.max = null; }
    else if (s[k]) s[k] = s[k].filter(function (x) { return x !== v; });
    return s;
  }
  function toggle(s, k, v) {
    if (!s[k]) return s;
    s[k] = s[k].indexOf(v) > -1 ? s[k].filter(function (x) { return x !== v; }) : s[k].concat([v]);
    return s;
  }

  /* ---- URL codec: only the f_* keys move; every other parameter is preserved ---- */
  var PARAM = { shape: 'f_shape', metal: 'f_metal', origin: 'f_origin', stone: 'f_stone', min: 'f_min', max: 'f_max', sort: 'f_sort' };
  function writeParams(params, s, sort) {
    LIST_GROUPS.forEach(function (k) {
      if (s[k].length) params.set(PARAM[k], s[k].join(',')); else params.delete(PARAM[k]);
    });
    if (s.min !== null) params.set(PARAM.min, String(s.min)); else params.delete(PARAM.min);
    if (s.max !== null) params.set(PARAM.max, String(s.max)); else params.delete(PARAM.max);
    if (sort && sort !== 'rank') params.set(PARAM.sort, sort); else params.delete(PARAM.sort);
    return params;
  }
  /* avail = availableValues() output; unknown values are dropped, never rendered. */
  function readParams(params, avail) {
    var s = cleanState();
    LIST_GROUPS.forEach(function (k) {
      var raw = params.get(PARAM[k]);
      if (!raw) return;
      var seen = {};
      raw.split(',').forEach(function (v) {
        v = v.trim().toLowerCase();
        if (v && !seen[v] && (avail ? avail[k].indexOf(v) > -1 : LABELS[k][v])) { seen[v] = 1; s[k].push(v); }
      });
    });
    ['min', 'max'].forEach(function (k) {
      var raw = params.get(PARAM[k]);
      if (raw === null || raw === '') return;
      var n = parseMoney(raw);
      if (n !== null && isFinite(n) && n >= 0) s[k] = round2(n);
    });
    if (s.min !== null && s.max !== null && s.min > s.max) { s.min = null; s.max = null; }
    var sort = params.get(PARAM.sort);
    return { state: s, sort: /^(rank|price-asc|price-desc|newest)$/.test(sort || '') ? sort : null };
  }

  return {
    SHAPE_LABEL: SHAPE_LABEL, SHAPE_ORDER: SHAPE_ORDER, SHAPE_ICONS: SHAPE_ICONS,
    METALS: METALS, METAL_ORDER: METAL_ORDER, METAL_LABEL: METAL_LABEL,
    ORIGIN_LABEL: ORIGIN_LABEL, STONE_LABEL: STONE_LABEL, LABELS: LABELS, ORDERS: ORDERS,
    LIST_GROUPS: LIST_GROUPS, GROUP_ORDER: GROUP_ORDER, PARAM: PARAM,
    metalKey: metalKey, metalOptionIndex: metalOptionIndex, metalsFromVariants: metalsFromVariants, metalsFromTitle: metalsFromTitle,
    normalizeProduct: normalizeProduct, shapeKey: shapeKey, carries: carries, photoMetals: photoMetals,
    cleanState: cleanState, cloneState: cloneState, hasPrice: hasPrice, selectedCount: selectedCount,
    isEmpty: isEmpty, sameState: sameState, validRange: validRange, parseMoney: parseMoney,
    configPrice: configPrice, metalFor: metalFor, matches: matches, countMatches: countMatches,
    optionCounts: optionCounts, availableValues: availableValues,
    presets: presets, sliderMax: sliderMax, money: money, priceLabel: priceLabel,
    entries: entries, remove: remove, toggle: toggle,
    writeParams: writeParams, readParams: readParams
  };
});
